// AboutSection.js - Estatica Skin and Laser

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/about/Hero.css";
import aboutPic from "../../../assets/images/aboutpic.png";

// Icons (using simple unicode/emoji as placeholders — swap with react-icons if preferred)
const stats = [
  {
    icon: "🏅",
    value: "9",
    label: "Board Certified",
  },
  {
    icon: "📋",
    value: "700+",
    label: "FDA Cleared Tools",
  },
  {
    icon: "👩‍⚕️",
    value: "5,000+",
    label: "Patients",
  },
];

const AboutSection = () => {
  return (
    <section className="estatica-about">
      <Container>
        {/* Top heading row */}
        <Row className="mb-5">
          <Col lg={7} md={10}>
            <p className="estatica-about__label">Our Story</p>
            <h2 className="estatica-about__heading">
              A modern skin &amp; laser <br />
              clinic built on trust.
            </h2>
          </Col>
        </Row>

        {/* Image + Content row */}
        <Row className="align-items-center">
          {/* Left: Image */}
          <Col lg={6} md={12} className="mb-4 mb-lg-0">
            <div className="estatica-about__image-wrapper">
              <img
                src="https://estetica.pk/cdn/shop/files/ChatGPT_Image_Jun_5_2026_06_36_02_PM.png?v=1780666579&width=3840"
                alt="Estatica Skin and Laser Clinic Team"
              />
            </div>
          </Col>

          {/* Right: Content */}
          <Col lg={6} md={12}>
            <div className="estatica-about__content">
              <h3 className="estatica-about__subheading">
                Dermatologist-led care since 2019.
              </h3>

              <p className="estatica-about__text">
                {/* Beautiful Skin Starts with the Right Care. */}
                <h3 className="estatica-about__subheading">Who We Are</h3>
                EsteticaSkin & Laser is a modern skincare and aesthetic clinic
                based in Gujranwala, established with the aim of providing
                professional, personalized, and accessible skincare and
                aesthetic services. The clinic was established in 2019 with a
                vision of creating a trusted space where people could receive
                professional guidance and modern treatments for their skin and
                aesthetic concerns. Estetica Skin & Laser focuses on combining
                skincare expertise, modern aesthetic technologies, and
                personalized treatment planning to help clients achieve
                healthier-looking skin and greater confidence. From skincare and
                facial treatments to laser and aesthetic procedures, the clinic
                provides services designed according to the individual needs and
                concerns of each client.
              </p>
              <h3 className="estatica-about__subheading">Our Story</h3>
              <p className="estatica-about__text">
                Estetica Skin & Laser was founded with a simple idea: every
                person deserves professional skincare that is based on their
                individual needs rather than a one-treatment-fits-all approach.
                The clinic was created to provide people in Gujranwala with a
                comfortable and professional environment where they could
                discuss their skincare concerns, understand their treatment
                options, and receive appropriate guidance. Since its
                establishment, the clinic has focused on concerns such as acne,
                pigmentation, acne scars, uneven skin tone, unwanted hair, dull
                skin, and signs of ageing. The goal has always been to make the
                skincare journey more comfortable and understandable for
                clients—from the initial consultation to treatment and follow-up
                care.
              </p>
              <h3 className="estatica-about__subheading">Our Approach</h3>
              <p className="estatica-about__text">
                At Estetica Skin & Laser, we believe that every person’s skin is
                different and requires individual attention. Our approach
                focuses on understanding each client’s skin concerns and
                aesthetic goals before recommending suitable treatments. We aim
                to combine professional skincare expertise with modern aesthetic
                and laser technologies to provide a comfortable, personalized,
                and informed treatment experience.
              </p>

              {/* Stats */}
              <div className="estatica-about__stats">
                {stats.map((stat, index) => (
                  <div className="estatica-about__stat-card" key={index}>
                    <div className="estatica-about__stat-icon">{stat.icon}</div>
                    <span className="estatica-about__stat-value">
                      {stat.value}
                    </span>
                    <span className="estatica-about__stat-label">
                      {stat.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
